import { render } from "./FinanceEducation.vue?vue&type=template&id=642e9a11&scoped=true"
import script from "./FinanceEducation.vue?vue&type=script&lang=js"
export * from "./FinanceEducation.vue?vue&type=script&lang=js"

import "./FinanceEducation.vue?vue&type=style&index=0&id=642e9a11&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642e9a11"]])

export default __exports__